import React from 'react';
import { TOUR_THEME } from './tourTheme';

const ARROW_DEPTH = 9;
const ARROW_BASE = 20;

/**
 * Flecha integrada al tooltip (reemplaza la de Joyride).
 * Joyride posiciona el tooltip con placement respecto al target:
 * - placement "right"  → panel a la derecha  → flecha apunta a la izquierda
 * - placement "left"   → panel a la izquierda → flecha apunta a la derecha
 * - placement "bottom" → panel debajo        → flecha apunta hacia arriba
 * - placement "top"    → panel arriba        → flecha apunta hacia abajo
 */
export function TourTooltipArrow({ placement }) {
  const side = (placement || 'bottom').split('-')[0];

  let position = {};
  let points = '';
  let width = 0;
  let height = 0;

  switch (side) {
    case 'right':
      position = { left: -ARROW_DEPTH + 1, top: '50%', transform: 'translateY(-50%)' };
      width = ARROW_DEPTH;
      height = ARROW_BASE;
      points = `${ARROW_DEPTH},${ARROW_BASE} ${ARROW_DEPTH},0 0,${ARROW_BASE / 2}`;
      break;
    case 'left':
      position = { right: -ARROW_DEPTH + 1, top: '50%', transform: 'translateY(-50%)' };
      width = ARROW_DEPTH;
      height = ARROW_BASE;
      points = `0,0 ${ARROW_DEPTH},${ARROW_BASE / 2} 0,${ARROW_BASE}`;
      break;
    case 'top':
      position = { bottom: -ARROW_DEPTH + 1, left: '50%', transform: 'translateX(-50%)' };
      width = ARROW_BASE;
      height = ARROW_DEPTH;
      points = `0,0 ${ARROW_BASE / 2},${ARROW_DEPTH} ${ARROW_BASE},0`;
      break;
    case 'bottom':
    default:
      position = { top: -ARROW_DEPTH + 1, left: '50%', transform: 'translateX(-50%)' };
      width = ARROW_BASE;
      height = ARROW_DEPTH;
      points = `0,${ARROW_DEPTH} ${ARROW_BASE / 2},0 ${ARROW_BASE},${ARROW_DEPTH}`;
      break;
  }

  return (
    <svg
      width={width}
      height={height}
      style={{
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: 2,
        display: 'block',
        ...position,
      }}
      aria-hidden
    >
      <polygon
        points={points}
        fill={TOUR_THEME.panelBgSolid}
        stroke={TOUR_THEME.panelBorder}
        strokeWidth={1}
        strokeLinejoin="round"
      />
    </svg>
  );
}
